
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { IDisputesState } from '@/store/modules/disputes';
import { ViewsInvoiceDisputes_DisputeCodesDocument, ViewsInvoiceDisputes_DisputeCodesQueryVariables } from '@/generated/graphql';
import { PropType } from 'vue';

export default Vue.extend({
	apollo: {
		disputeCodes: {
			query: ViewsInvoiceDisputes_DisputeCodesDocument,
			variables(): ViewsInvoiceDisputes_DisputeCodesQueryVariables {
				return {
					'participant': this.selectedParticipantStore
				};
			}
		}
	},
	props: {
		onFilter: {
			type: Function,
			required: false,
			default: null
		}
	},
	computed: {
		...mapGetters(['participantUsers', 'selectedParticipantStore', 'selectedLegalEntityStore']),
		...mapState('disputes', {
			filterDisputeCodes: (state: IDisputesState) => state.filterDisputeCodes,
			// Gets reset on participant or entity change in store/index.js
			filterAssignee: (state: IDisputesState) => state.filterAssignee,
			filterDue: (state: IDisputesState) => state.filterDue
		}),
		sortedDisputeCodes() {
			return [...this.disputeCodes || []]
				.filter((dispute_code) => {
					return dispute_code.default_days_to_suspend !== -1;
				})
				.sort((a, b) => {
					if (this === undefined) {
						return a.code < b.code ? -1 : 1;
					}
					// Sort alphabettially in the locale of the user
					return (this.$translate.dispute_code(a.code) < this.$translate.dispute_code(b.code)) ? -1 : 1;
				});
		}
	},
	methods: {
		handleFilter() {
			if (typeof this.onFilter === 'function') {
				this.onFilter();
			}
		},
		handleShowUrgentClick() {
			if (this.filterDue) {
				this.$store.commit('disputes/SET_FILTER_DUE', null);
			} else {
				this.$store.commit('disputes/SET_FILTER_DUE', new Date());
			}
		},
		handleDisputeCodesFilterChange(value) {
			this.$store.commit('disputes/SET_FILTER_DISPUTE_CODES', value);
		},
		handleAssigneeFilterChange(value) {
			this.$store.commit('disputes/SET_FILTER_ASSIGNEE', value);
		},
		handleAssignedToMeClick() {
			if (this.filterAssignee !== this.$store.state.risolto.loggedInUser.reference) {
				this.$store.commit('disputes/SET_FILTER_ASSIGNEE', this.$store.state.risolto.loggedInUser.reference);
			} else {
				this.$store.commit('disputes/SET_FILTER_ASSIGNEE', null);
			}
		}
	}
});
